
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import NavigationLayout from "components/layout/NavigationLayout";
import { getLocalizedSSRAxios } from "api";
import { useContext, useEffect, useState } from "react";
import styles from "pages/palette/[pid]/index.module.scss";
import PostGrid from "components/layout/PostGrid";
import utilStyles from "styles/utils.module.scss";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import UserContext from "context/AuthContext";
import { productScrapContextRef } from "context/ProductScrapContext";
import { postScrapContextRef } from "context/PostScrapContext";
import { useRouter } from "next/router";
import Head from "next/head";
import { getYoutubeThumbnailLink } from "components/media/youtube";
import { ImageDetailContextProvider } from "context/ImageDetailContext";
import { PostCard } from "components/cards/palette/PostCard";
import PostListContext, { postListContextRef } from "context/PostListContext";
import classNames from "classnames";
import TitleBar from "components/layout/TitleBar";
import ReportedPostCard from "components/cards/palette/ReportedPostCard";
import ErrorPage from "components/ErrorPage";
import useTranslation from "next-translate/useTranslation";
import { setCountryCodeInCookieSSR } from "common/i18n";
function PostDetail(props) {
    const { ssrError, notFound, post } = props;
    const isMobile = useMediaQuery(`(max-width:${utilStyles.breakpointMobile})`);
    const userContext = useContext(UserContext);
    const { reportedPostIds, addPostIds } = useContext(PostListContext);
    const user = userContext.user;
    const router = useRouter();
    const isBot = router.query.is_bot;
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        setTimeout(() => {
            scrollTo(0, 0);
        }, 1);
    }, []);
    useEffect(() => {
        if (!router.isReady) {
            return;
        }
    }, [user, router.isReady]);
    const [isMetadataRecorded, setIsMetadataRecorded] = useState(false);
    useEffect(() => {
        if (post && productScrapContextRef.current && postScrapContextRef.current && postListContextRef.current && !isMetadataRecorded) {
            productScrapContextRef.current.addProductIds(post['scrapped_product_ids'] ?? []);
            postScrapContextRef.current.addPostIds(post['scrapped_post_ids'] ?? []);
            postListContextRef.current.addReportedPostIds(post['reported_post_ids'] ?? []);
            setIsMetadataRecorded(true);
        }
    }, [post, productScrapContextRef.current, postScrapContextRef.current, postListContextRef.current]);
    const [modalState, setModalState] = useState(0);
    const localOptionSwiperIndex = {};
    useEffect(() => {
        window.onpopstate = (a) => setModalState(val => val + 1);
    }, []);
    const metaTitle = (post?.text?.length > 50 ? post.text.substring(0, 50) + '...' : post?.text || '').split('\n').join(' ');
    let metaDescription = (post?.text?.length > 50 ? post.text.substring(0, 50) + '...' : post?.text || '').split('\n').join(' ');
    if (post && post?.product_options && post.product_options.length > 0) {
        for (const option of post.product_options) {
            console.log(option);
            metaDescription += ` #${option.brand_name}-${option.product_name || option.name}`;
            if (option.product_name) {
                metaDescription += `(${option.name})`;
            }
        }
    }
    const onPostClick = (post, itemIdx) => {
        typeof mixpanel !== 'undefined' && mixpanel.track('PostDetailRecommendPostClick', {
            postId: post.id,
            itemIdx
        });
    };
    const recommendedPosts = post && post.writers_post ? post.writers_post.filter(post => !reportedPostIds.has(post.id)) : [];
    const { t } = useTranslation('palette-pid-index');
    return (<>
            <Head>
                <meta name="description" content={metaDescription} key="description"/>
                <title>{metaTitle}</title>
                <meta property="og:type" content="website" key="ogType"/>
                <meta property="og:title" content={metaTitle} key="ogTitle"/>
                <meta property="og:description" content={metaDescription} key="ogDescription"/>
                {post && post.media_list.length > 0 ?
            (post.media_list[0].type === 'youtube' ?
                <meta property="og:image" content={getYoutubeThumbnailLink(post.media_list[0].url)} key="ogImage"/>
                :
                    (post.media_list[0].type === 'video' ?
                        <meta property="og:video" content={post.media_list[0].url} key="ogImage"/>
                        :
                            <meta property="og:image" content={post.media_list[0].url} key="ogImage"/>))
            :
                <></>}
                <link rel="icon" href="/favicon-v2.ico" type="image/x-icon"/>
                <link rel="shortcut icon" href="/favicon-v2.ico" type="image/x-icon"/>
            </Head>
            <ImageDetailContextProvider>
                <div className={styles.container}>
                    <div className={classNames(utilStyles.newSidePadding, utilStyles.topSticky, utilStyles.whiteBackground)}>
                        <TitleBar isBack title={post ? t('PostDetail.postTitle', { nickname: post.user.nickname }) : ''} close={() => router.back()} home/>
                    </div>
                    {post ?
            <>
                                {reportedPostIds.has(post.id)
                    ? <ReportedPostCard />
                    : <PostCard isDetailPage={true} setModalState={setModalState} measure={() => {
                        }} item={post} optionSwiperIndex={localOptionSwiperIndex} autoplay/>}
                                {isMobile && <div className={utilStyles.mobileBorder}/>}
                                <div className={styles.section}>
                                    <span className={styles.sectionTitle}>{t('PostDetail.recommendedFeed')}</span>
                                    <div>
                                        <PostGrid posts={recommendedPosts} size={6} smallMargin onPostClick={onPostClick}/>
                                    </div>
                                </div>
                            </> :
            <ErrorPage title={t('PostDetail.postNotFound')} content={t('PostDetail.postNotFoundDescription')}/>}
                </div>
            </ImageDetailContextProvider>
        </>);
}
PostDetail.getLayout = NavigationLayout;
async function getServerSideProps(context) {
    const { countryCode } = setCountryCodeInCookieSSR(context);
    let post = null;
    let notFound = false;
    let error = false;
    try {
        const axios = getLocalizedSSRAxios(countryCode);
        const res = await axios.get(`v1/palette/posts/${context.params.pid}`, {
            params: { is_bot: true },
            headers: { Cookie: context.req.headers.cookie || '' }
        });
        if (res.status < 400) {
            post = res.data;
        }
        else if (res.status === 404) {
            notFound = true;
        }
        else {
            error = true;
        }
    }
    catch (e) {
        error = true;
    }
    return {
        props: {
            notFound: notFound,
            post: post,
            ssrError: error,
            countryCode
        }
    };
}
export default PostDetail;

    async function __Next_Translate__getServerSideProps__1966fcd8765__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/palette/[pid]/index',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1966fcd8765__ as getServerSideProps }
  